import React, { useEffect, useState } from 'react';
import { CnMessage as UICnMessage } from '@cainiaofe/cn-ui';
import { CnDataSourceChange, onEvent } from '@/common/util/event-name';
// eslint-disable-next-line import/no-cycle
import {
  calculateTextExprValue,
  executeFunction,
  getSlotDom,
  isArrayNotEmpty,
  mergeHandleProps2,
} from '@/common/util/util';

const CnMessage = (props) => {
  const {
    content = '',
    _context,
    getContext,
    _getFormValue,
    visible,
    type,
    title,
    ...rest
  } = props;
  const titleSlotDom = getSlotDom({
    componentSlot: title,
    componentProps: {},
  });
  const { needMargin } = rest || {};
  let realContent = content;
  let state = _context?.state;
  const [, setForceUpdate] = useState();
  if (!state && typeof getContext === 'function') {
    state = getContext()?.state || {};
  }
  const formValue = _getFormValue?.();

  useEffect(() => {
    if (typeof content === 'function') {
      onEvent(CnDataSourceChange, () => {
        setForceUpdate(Date.now());
      });
    }
  }, []);

  if (typeof content === 'function') {
    realContent = content(state, formValue || {});
  }

  const realVisible = calculateTextExprValue(visible, {
    recordDataSource: {},
    state,
  });

  let extraProps = {};
  if (needMargin === true) {
    extraProps.style = {
      margin: '12px 0',
    };
  } else if (isArrayNotEmpty(needMargin)) {
    extraProps.style = {};
    needMargin.forEach((item) => {
      if (item === true) {
        extraProps.style.margin = '12px 0';
      } else if (typeof item === 'string') {
        extraProps.style[`margin-${item}`] = '12px';
      }
    });
  }
  extraProps.type = type;
  if (typeof type === 'function') {
    extraProps.type = executeFunction(type, formValue || {}, state);
  }

  extraProps = mergeHandleProps2({
    handleProps: props?.handleProps,
    componentProps: extraProps,
    _context: props?._context,
  });

  return realVisible !== false ? (
    <UICnMessage title={titleSlotDom} {...rest} {...extraProps}>
      {realContent}
    </UICnMessage>
  ) : (
    ''
  );
};
CnMessage.displayName = 'CnMessage';
export default CnMessage;

export { CnMessage };
